import { useState, useEffect } from 'react';
import { BasicTable, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { Modal } from '../../theme/Component/Modal';
import { ProcedureAction } from './ProcedureAction';
import { ActualProcedure } from './ActualProcedure';
import { ModalGeneric } from '../../../interfaces';
import { HandlerInfoProcess } from './InfoTramiteComponents/HandlerInfoProcess';
import { JsonFormaterInput } from '../../theme/Component/JsonFormaterInput';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _Inbox } from '../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';


interface Props {
    acc: any;
    type: number;
}
export const ProcedureIMP = ({ acc, type }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_Inbox);
    const [process, setProcess] = useState<any>({});
    const [modalTrack, setModalTrack] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalHisto, setModalHisto] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalHistory, setModalHistory] = useState<ModalGeneric>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalProps, setModalProps] = useState<ModalGeneric>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const setRowBeanTramites = (beanT: any) => {
        setBean(beanT);
    }

    useEffect(() => {
        if (acc.IDAccount)
            if (type === 0)
                getTramites();
        if (type === 1)
            getTramitesByCode();
    }, [acc, type])


    const getTramites = () => {
        instance.getProcedureImpByAccount(acc.IDAccount).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(err => {
            toast.error(err)
        })
    }

    const getRequestProcessBpmByImp = () => {
        instance.getRequestProcessBpmByImp(bean.IDProcedureImp).then(
            (resp) => {
                setProcess(resp)
            }
        ).catch(err => {
            toast.error(err)
        });
    }

    const getTramitesByCode = () => {
        instance.getProcedureImpByAlphaCode(acc.AlphaCode).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(err => {
            toast.error(err)
        })
    }
    const updateProcedure=()=>{
        console.log(process);
        instance.updateRequestProcessBpm(process).then((resp:any)=>{
            console.log(resp);
            setProcess(resp);
            
        })
        
    }

    const headtramites = [
        { title: 'ID del Tramite', property: 'IDProcedureImp', mask: MASK_NUMBER },
        { title: 'Solicitud', property: 'BusinessProcessName' },
        { title: 'No. Radicado', property: 'AlphaCode' },
        { title: 'Fecha de Inicio', property: 'Since' },
        { title: 'Ultimo Funcionario', property: 'LastEmployeeName' },
        { title: 'Tarea', property: 'ProcedureName' },
        { title: 'Estado', property: 'StateName' },
    ]

    const listaBotonesT = () => {
        const botones = [
            { titulo: 'Actividad', icono: 'ri-hard-drive-2-line', visible: true, evento: () => { setModalHisto({ ...modalHisto, "view": true }) } },
            { titulo: '¿En donde esta el Tramite?', icono: 'ri-hard-drive-2-line', visible: true, evento: () => { setModalTrack({ ...modalTrack, "view": true }) } },
            { titulo: 'Resumen', icono: 'ri-edit-2-line', visible: true, evento: () => { setModalHistory({ ...modalHistory, "view": true, "name": "Historico del Procedimiento" }) } },
            { titulo: 'Propiedades', icono: 'ri-code-s-slash-fill', visible: true, evento: () => { getRequestProcessBpmByImp(); setModalProps({ ...modalProps, "view": true, "name": "Propiedades" }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <>
            <div className="row">
                <div className="col">
                    <BasicTable listButtons={listaBotonesT()} body={lista} rowSet={setRowBeanTramites} head={headtramites}></BasicTable>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalHisto} updateModal={setModalHisto}  >
                        <>
                            <ProcedureAction IDProcedure={bean.IDProcedureImp}></ProcedureAction>
                        </>
                    </Modal>

                    <Modal modal={modalTrack} updateModal={setModalTrack}  >
                            <ActualProcedure IDProcedure={bean.IDProcedureImp}></ActualProcedure>
                    </Modal>

                    <Modal modal={modalHistory} updateModal={setModalHistory} >
                        <HandlerInfoProcess _ProcedureIMPID={bean.IDProcedureImp} />
                    </Modal>

                    <Modal modal={modalProps} updateModal={setModalProps} eventModal={updateProcedure}>
                        <div className="row">
                            <div className="col">
                                <JsonFormaterInput value={process.JSONProps} inputType='string' _label='Propiedades' onChange={(e) => {setProcess({...process,"JSONProps":e})}} returnType='string' />
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </>
    )
}